/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Bland_Bobcat_StriveInputs */

const fr_salty_bland_bobcat_strive = /** @type {(inputs: Salty_Bland_Bobcat_StriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

/**

* @param {Salty_Bland_Bobcat_StriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_bland_bobcat_strive = /** @type {((inputs?: Salty_Bland_Bobcat_StriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Bland_Bobcat_StriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_bland_bobcat_strive(inputs)
});